export default {
  ticketList: [],
  headersSettings: {},
  sevenTaxes: {},
};
